(function () {
  'use strict';
  if (window.__fizzySampleV2Motion) return;
  window.__fizzySampleV2Motion = true;

  var instances = new Map();
  function init(group) {
    if (instances.has(group)) return;
    var cards = Array.from(group.querySelectorAll('[data-sv-motion-card]'));
    var toggle = group.querySelector('[data-sv-motion-toggle]');
    var track = group.querySelector('.sv-habits__track');
    var list = group.querySelector('.sv-habits__list');
    var status = group.querySelector('[data-sv-motion-status]');
    if (!toggle || !track || !list || !status || !('IntersectionObserver' in window)) return;

    var preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    var paused = false;
    var disposed = false;
    var focusFrame = 0;
    var visible = new Map();
    var selectedHabits = new Set();
    var originals = Array.from(list.querySelectorAll('[data-sv-habit]')).map(function (button) {
      return { button: button, pressed: button.getAttribute('aria-pressed'), struck: button.classList.contains('is-struck') };
    });
    var habitKeys = new Set(originals.map(function (original) { return original.button.getAttribute('data-sv-habit'); }));
    // The expanded set is taller than the viewing window; one trailing copy
    // makes the seam continuous without showing an item twice in that window.
    var clones = [list.cloneNode(true)];
    clones.forEach(function (clone) {
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-sv-motion-clone', '');
      clone.querySelectorAll('[data-sv-habit]').forEach(function (button) { button.setAttribute('tabindex', '-1'); });
      track.appendChild(clone);
    });
    var habits = Array.from(track.querySelectorAll('[data-sv-habit]'));
    habits.forEach(function (button) {
      button.setAttribute('aria-pressed', 'false');
      button.classList.remove('is-struck');
    });
    group.setAttribute('data-sv-motion-ready', '');

    function onHabitClick(event) {
      var button = event.target.closest('[data-sv-habit]');
      if (!button || !track.contains(button) || button.disabled) return;
      var key = button.getAttribute('data-sv-habit');
      if (!habitKeys.has(key)) return;
      var selected = !selectedHabits.has(key);
      if (selected) selectedHabits.add(key);
      else selectedHabits.delete(key);
      habits.forEach(function (habit) {
        if (habit.getAttribute('data-sv-habit') !== key) return;
        habit.setAttribute('aria-pressed', String(selected));
        habit.classList.toggle('is-struck', selected);
      });
    }

    function onHabitPointerDown(event) {
      var button = event.target.closest('[data-sv-habit]');
      if (button && track.contains(button) && button.closest('[data-sv-motion-clone]')) event.preventDefault();
    }

    function cancelFocusCorrection() {
      if (focusFrame) cancelAnimationFrame(focusFrame);
      focusFrame = 0;
    }

    function onHabitFocus(event) {
      cancelFocusCorrection();
      var button = event.target.closest('[data-sv-habit]');
      if (!button || !track.contains(button) || button.closest('[data-sv-motion-clone]') || !button.matches(':focus-visible')) return;
      focusFrame = requestAnimationFrame(function () {
        focusFrame = 0;
        if (disposed || !button.isConnected || document.activeElement !== button || !button.matches(':focus-visible')) return;
        button.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    }

    function sync() {
      var enabled = !paused && !preference.matches;
      toggle.disabled = preference.matches;
      toggle.setAttribute('aria-checked', String(enabled));
      toggle.title = preference.matches ? 'Animations are off for reduced motion' : enabled ? 'Pause card animations' : 'Play card animations';
      cards.forEach(function (card) {
        card.setAttribute('data-sv-running', String(enabled && !document.hidden && visible.get(card) === true));
      });
    }

    function onToggle() {
      paused = !paused;
      sync();
      status.textContent = paused ? 'Card animations paused.' : 'Card animations playing.';
    }

    // Only visible cards run. Hidden tabs and reduced-motion preferences stop all loops.
    var observer = new IntersectionObserver(function (entries) {
      if (disposed) return;
      entries.forEach(function (entry) { visible.set(entry.target, entry.isIntersecting); });
      sync();
    }, { threshold: 0 });
    cards.forEach(function (card) {
      visible.set(card, false);
      if (observer) observer.observe(card);
    });
    toggle.addEventListener('click', onToggle);
    track.addEventListener('click', onHabitClick);
    track.addEventListener('pointerdown', onHabitPointerDown);
    track.addEventListener('focusin', onHabitFocus);
    track.addEventListener('focusout', cancelFocusCorrection);
    document.addEventListener('visibilitychange', sync);
    if (preference.addEventListener) preference.addEventListener('change', sync);
    else preference.addListener(sync);
    sync();

    instances.set(group, function () {
      disposed = true;
      if (observer) observer.disconnect();
      toggle.removeEventListener('click', onToggle);
      track.removeEventListener('click', onHabitClick);
      track.removeEventListener('pointerdown', onHabitPointerDown);
      track.removeEventListener('focusin', onHabitFocus);
      track.removeEventListener('focusout', cancelFocusCorrection);
      cancelFocusCorrection();
      document.removeEventListener('visibilitychange', sync);
      if (preference.removeEventListener) preference.removeEventListener('change', sync);
      else preference.removeListener(sync);
      clones.forEach(function (clone) { clone.remove(); });
      originals.forEach(function (original) {
        if (original.pressed === null) original.button.removeAttribute('aria-pressed');
        else original.button.setAttribute('aria-pressed', original.pressed);
        original.button.classList.toggle('is-struck', original.struck);
      });
      selectedHabits.clear();
      group.removeAttribute('data-sv-motion-ready');
      cards.forEach(function (card) { card.removeAttribute('data-sv-running'); });
    });
  }

  function scan(scope) {
    if (scope.matches && scope.matches('[data-sv-motion]')) init(scope);
    scope.querySelectorAll('[data-sv-motion]').forEach(init);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (dispose, group) {
      if (event.target === group || event.target.contains(group)) {
        dispose();
        instances.delete(group);
      }
    });
  });
})();
